{
  "pages": {
    "tickets": {
      "title": "Tickets",
      "createTitle": "Create ticket",
      "loading": "Loading ticket…"
    },
    "reports": {
      "title": "Desk reports"
    },
    "cannedResponses": {
      "title": "Canned responses"
    },
    "inbox": {
      "title": "Desk Inbox"
    },
    "setup": {
      "title": "Desk Setup"
    },
    "workflowDesigner": {
      "title": "Workflow designer"
    },
    "boards": {
      "title": "Desk Boards"
    },
    "knowledgeBase": {
      "title": "Knowledge Base"
    },
    "automation": {
      "title": "Desk Automation"
    },
    "liveChat": {
      "title": "Live Chat"
    },
    "support360": {
      "description": "Customer Support 360 — tickets, CRM, finance, and omnichannel history",
      "loading": "Loading support profile…"
    },
    "dashboard": {
      "title": "Desk Dashboard",
      "description": "Support volume, SLA health, and queue status for your access level",
      "queueDetails": "Queue details",
      "unassigned": "Unassigned",
      "totalTickets": "Total tickets"
    },
    "ruleBasedTriggersOnTicketAnd": "Rule-based triggers on ticket and SLA events",
    "kanbanViewOfTicketsByWorkflow": "Kanban view of tickets by workflow status",
    "reusableReplySnippetsForAgents": "Reusable reply snippets for agents",
    "noCannedResponsesYet": "No canned responses yet",
    "emailConversationsLinkedToTicketsReply": "Email conversations linked to tickets — reply via SMTP",
    "categoriesAndArticlesForAgentsAnd": "Categories and articles for agents and customer portal",
    "realtimeCustomerConversations": "Realtime customer conversations",
    "ticketVolumeSlaBreachesAndAgent": "Ticket volume, SLA breaches, and agent performance",
    "statuses": "Statuses",
    "priorities": "Priorities",
    "teams": "Teams",
    "statusesPrioritiesTeamsInboundMailboxImap": "Statuses, priorities, teams, inbound mailbox, IMAP polling, customer portal, business hours",
    "defineAllowedStatusTransitionsAndRole": "Define allowed status transitions and role ACLs",
    "omnichannelSupportTicketsWithConfigurableWorkflows": "Omnichannel support tickets with configurable workflows"
  },
  "toast": {
    "ticketCreated": "Ticket created",
    "workflowCreated": "Workflow created",
    "transitionAdded": "Transition added",
    "cannedResponseUpdated": "Canned response updated",
    "cannedResponseCreated": "Canned response created",
    "categoryCreated": "Category created",
    "articleCreated": "Article created",
    "imapSettingsSaved": "IMAP settings saved",
    "inboundProcessed": "Processed {{count}} inbound messages",
    "replySent": "Reply sent",
    "timelineAdded": "Added to timeline",
    "statusUpdated": "Status updated",
    "attachmentAdded": "Attachment added",
    "csatRecorded": "CSAT recorded",
    "reportExported": "Report exported as {{format}}"
  },
  "errors": {
    "loadReportsFailed": "Failed to load desk reports",
    "exportFailed": "Export failed",
    "createFailed": "Create failed",
    "createWorkflowFailed": "Failed to create workflow",
    "addTransitionFailed": "Failed to add transition",
    "loadCannedResponsesFailed": "Failed to load canned responses",
    "saveFailed": "Save failed",
    "deleteFailed": "Delete failed",
    "createCategoryFailed": "Failed to create category",
    "createArticleFailed": "Failed to create article",
    "loadSupport360Failed": "Failed to load Customer Support 360",
    "loadSetupFailed": "Failed to load desk setup",
    "updateCalendarFailed": "Failed to update business calendar",
    "addHolidayFailed": "Failed to add holiday",
    "saveImapFailed": "Failed to save IMAP settings",
    "syncFailed": "Sync failed",
    "loadLiveChatsFailed": "Failed to load live chats",
    "loadThreadFailed": "Failed to load thread",
    "sendReplyFailed": "Failed to send reply",
    "loadTicketFailed": "Failed to load ticket",
    "addCommentFailed": "Failed to add comment",
    "transitionFailed": "Transition failed",
    "uploadFailed": "Upload failed",
    "recordCsatFailed": "Failed to record CSAT",
    "loadInboxFailed": "Failed to load inbox",
    "loadMessagesFailed": "Failed to load messages",
    "loadAutomationFailed": "Failed to load automation rules",
    "loadBoardFailed": "Failed to load board",
    "failedToLoadTickets": "Failed to load tickets"
  },
  "labels": {
    "title": "Title",
    "shortcutCode": "Shortcut code",
    "categoryCode": "Category code",
    "body": "Body",
    "replyToCustomer": "Reply to customer",
    "name": "Name",
    "category": "Category",
    "content": "Content",
    "none": "— None —",
    "agentReply": "Agent reply",
    "totalTickets": "Total tickets",
    "openTickets": "Open tickets",
    "unassigned": "Unassigned",
    "slaBreaches": "SLA breaches",
    "averageCsat": "Average CSAT",
    "imapHost": "IMAP host",
    "port": "Port",
    "username": "Username",
    "password": "Password",
    "calendarName": "Calendar name",
    "timezone": "Timezone",
    "workStart": "Work start",
    "workEnd": "Work end",
    "date": "Date",
    "passwordAppPassword": "Password (app password)",
    "newWorkflowName": "New workflow name",
    "fromStatus": "From status",
    "toStatus": "To status",
    "allowedRoleCodeOptional": "Allowed role code (optional)",
    "invoices": "Invoices",
    "avgCsat": "Avg CSAT",
    "rating": "Rating",
    "feedbackOptional": "Feedback (optional)",
    "replyNote": "Reply / note",
    "subject": "Subject *"
  },
  "formActions": {
    "saveImap": "Save IMAP",
    "saveCalendar": "Save calendar",
    "addHoliday": "Add holiday",
    "addTransition": "Add transition",
    "createWorkflow": "Create workflow",
    "addToTimeline": "Add to timeline"
  },
  "listActions": {
    "newTicket": "New ticket",
    "workflowDesigner": "Workflow designer",
    "cannedResponses": "Canned responses",
    "sendReply": "Send reply"
  }
}
